import NoSpecialsAvailableModal from './NoSpecialsAvailableModal';

export default NoSpecialsAvailableModal;
